import LenderSearchBusinessResults from './LenderSearchBusinessResults';

export default LenderSearchBusinessResults;
